/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2022. All Rights Reserved.
 #*
 #*===================================================================
 */

import { PriceConfigExtended, PriceConfigDescription } from './price-config.model';
import { Client } from '@truckstop-tms/zuum-lib';

export interface ClientAddOn {
  id: number;
  clientId: number;
  priceConfigDescriptionId: number;
  client: Client;
  priceConfigDescription: PriceConfigDescription;
  priceConfig: PriceConfigExtended;
  enabled: boolean;
  updatedBy: string;
  activatedAt: Date;
  deactivatedAt: Date | null;
}

export enum ADD_ON_TYPES {
  ZUUM_TEXT_UNLIMITED = 'ZUUM_TEXT_UNLIMITED',
  DIRECT_EMAIL = 'DIRECT_EMAIL',
  DIALPAD = 'DIALPAD',
  EDI_INTEGRATION = 'EDI_INTEGRATION',
  QUICKBOOK = 'QUICKBOOK',
  TRIUMPH_PAY = 'TRIUMPH_PAY',
  EDI_CHECK_CALL = 'EDI_CHECK_CALL',
  DAT = 'DAT',
  TRUCK_STOP = 'TRUCK_STOP',
  APPLY_FOR_CREDIT = 'APPLY_FOR_CREDIT',
  TBC_INTEGRATION = 'TBC_INTEGRATION',
  LTL = 'LTL',
  MACROPOINT = 'MACROPOINT',
  Z_SCAN_W9 = 'Z_SCAN_W9',
  Z_SCAN_INSURANCE = 'Z_SCAN_INSURANCE',
  DWOLLA = 'DWOLLA',
  ZUUM_SIGN_CARRIER_RATE_CONFIRMATION = 'ZUUM_SIGN_CARRIER_RATE_CONFIRMATION',
  ZUUM_SIGN_CARRIER_ONBOARDING = 'ZUUM_SIGN_CARRIER_ONBOARDING',
  ZUUM_TEXT = 'ZUUM_TEXT',
  SLA_SUPPORT = 'SLA_SUPPORT',
}
